import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const textColor = '#393939';
const primaryBlue = '#092b4a';
const borderColor = primaryBlue;

const cellProperties = {
  padding: 4,
  paddingLeft: 4,
  fontSize: 8,
  color: textColor,
  alignSelf: 'stretch',
  whiteSpace: 'break-spaces',
  fontFamily: 'NunitoRegular',
  borderRightColor: borderColor,
  borderRightWidth: 1,
};
const headProperties = {
  paddingRight: 5,
  paddingLeft: 5,
  fontSize: 8,
  color: 'white',
  textTransform: 'uppercase',
  whiteSpace: 'break-spaces',
  fontFamily: 'NunitoMedium',
};

const styles = StyleSheet.create({
  headerContainer: { marginTop: 24 },
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 10,
    marginBottom: 20,
  },
  container: {
    flexDirection: 'row',
    padding: '4px 2px',
    backgroundColor: primaryBlue,
    color: 'white',
    alignItems: 'center',
    flexGrow: 1,
  },
  title: {
    fontSize: 9,
    textTransform: 'uppercase',
    backgroundColor: '#f0f0f0',
    color: primaryBlue,
    padding: '4px 35px',
    textAlign: 'center',
    marginBottom: 5,
    lineHeight: 'normal',
    fontFamily: 'NunitoMedium',
    borderBottom: `2px solid ${primaryBlue}`,
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
  },
  altRow: { backgroundColor: '#f5f5f5', },
  header20: {
    ...headProperties,
    width: '20%',
  },
  cell20: {
    ...cellProperties,
    width: '20%',
  },
  header30: {
    ...headProperties,
    width: '30%',
  },
  cell30: {
    ...cellProperties,
    width: '30%',
  },
  noDataRow: {
    fontSize: 9,
    width: '100%',
    textAlign: 'center',
    padding: 4,
    color: textColor,
    fontFamily: 'NunitoRegular',
  },
  noBorderRight: { borderRight: 'none', },
});

const UldDetailsTable = (props) => {

  const { awbs, uld_no } = props;

  return (
    <>
      <View style={styles.headerContainer}>
        <Text style={styles.title}>ULD Details - {uld_no}</Text>
        <View style={styles.tableContainer} wrap={true}>
          <View style={styles.container}>
            <View style={styles.header30}><Text>AWB Number</Text></View>
            <View style={styles.header20}><Text>Pcs</Text></View>
            <View style={styles.header20}><Text>Wgt</Text></View>
            <View style={styles.header20}><Text>O-D</Text></View>
            <View style={styles.header30}><Text>SPLs</Text></View>
            <View style={styles.header30}><Text>Remarks</Text></View>
          </View>

          {awbs && awbs.length > 0 ?
            awbs.map((awb, index) => (
              <View style={[
                styles.tableRow,
                index % 2 === 1 && styles.altRow // Apply altRow to odd rows
              ]} key={index}>
                <View style={styles.cell30}><Text>{awb.awb_no}</Text></View>
                <View style={styles.cell20}><Text>{awb.pcs}</Text></View>
                <View style={styles.cell20}><Text>{awb.wgt}</Text></View>
                <View style={styles.cell20}><Text>{awb.org}-{awb.dest}</Text></View>
                <View style={styles.cell30}><Text>{awb.spl_code}</Text></View>
                <View style={styles.cell30}><Text>{awb.remark}</Text></View>
              </View>
            )): <View style={styles.noDataRow}>
              <Text>No Data</Text>
            </View>}
        </View>
      </View>

    </>
  );
};
  
export default UldDetailsTable;